import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ForgotPasswordFormBuilder } from './forgot-password-form.builder';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ForgotPasswordFormBuilder],
})
export class ForgotPasswordFormComponent implements OnInit, OnChanges {
  @Input() disabled = false;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  @Output()
  onForgotPasswordSubmit: EventEmitter<string> = new EventEmitter<string>();

  formKeys: any;
  form: FormGroup;

  constructor(private _forgotPasswordFormBuilder: ForgotPasswordFormBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.form) {
      if (this.disabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }

  ngOnInit() {
    this.formKeys = this._forgotPasswordFormBuilder.FORM_KEYS;
    this.form = this._forgotPasswordFormBuilder.buildForm();
  }

  get emailAddress() {
    return this.form.get(this.formKeys.EMAIL_ADDRESS);
  }

  submit() {
    if (this.form.invalid) {
      this.emailAddress.markAsDirty();
      return;
    }

    const email = this.emailAddress.value;
    this.onForgotPasswordSubmit.emit(email);

    // clear the form to avoid duplicate submit
    this.form.reset();
  }
}
